'use client';

import * as React from 'react';

import { APP_NAME } from '@workspace/common/app';
import { cn } from '@workspace/ui/lib/utils';

export type LogoElement = React.ComponentRef<'div'>;
export type LogoProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
  hideWordmark?: boolean;
};
export function Logo({
  hideSymbol,
  hideWordmark,
  className,
  ...other
}: LogoProps): React.JSX.Element {
  return (
    <div
      className={cn('flex items-center space-x-2', className)}
      {...other}
    >
      {!hideSymbol && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 105.72107 105.74864"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="size-6 shrink-0 text-primary"
        >
          <g transform="translate(707.08163,-143.69028)">
            <path
              fill="currentColor"
              d="m -621.15379,246.09101 c 1.21442,-2.07949 2.23928,-5.35719 2.38273,-7.62053 0.15706,-2.47762 -0.37476,-5.78533 -1.25773,-7.82286 -0.49122,-1.13349 -2.60098,-4.61531 -3.09674,-5.11063 -0.0179,-0.0179 1.78322,-1.78352 4.00274,-3.92341 2.37368,-2.28867 4.73675,-4.79115 5.73871,-6.07725 8.22516,-10.55864 12.25337,-21.92194 12.01333,-33.88863 -0.16256,-8.10361 -2.15451,-14.8843 -6.24405,-21.25473 -1.84311,-2.87114 -7.54954,-8.57758 -10.42066,-10.42069 -9.05702,-5.81413 -20.00126,-7.6292 -31.90734,-5.29173 -5.96455,1.17101 -13.45824,4.28471 -18.63058,7.74123 -4.31729,2.88508 -6.65685,4.87354 -10.77946,9.16167 -2.17437,2.26174 -3.97727,4.01114 -4.00653,3.8875 -0.0862,-0.36476 -3.31866,-2.38231 -4.95909,-3.09517 -2.00894,-0.87299 -5.32595,-1.40377 -7.79461,-1.24731 -3.44263,0.21823 -7.99982,2.12536 -10.10211,4.22766 l -0.86648,0.86646 14.7693,14.76931 14.76929,14.7693 0.12117,-0.78776 c 0.99119,-6.4443 2.99201,-11.50319 6.66892,-16.86192 2.17636,-3.17182 7.18899,-8.1822 10.40427,-10.39988 11.47914,-7.91668 24.90644,-8.9149 33.84479,-2.51612 6.26346,4.48389 9.26788,13.99493 7.31675,23.16256 -1.69676,7.97249 -4.98402,13.91466 -11.04776,19.97041 -6.60358,6.59476 -13.39229,10.06807 -22.38125,11.45067 l -0.78775,0.12117 14.76928,14.76928 14.76931,14.76931 0.94614,-0.97268 c 0.52036,-0.53501 1.31474,-1.6039 1.76528,-2.37537 z m -48.86419,-33.71556 c -13.77515,-13.77515 -25.09696,-24.99449 -25.15962,-24.93183 -0.0627,0.0627 -0.32021,1.16047 -0.57236,2.43961 -2.15439,10.92881 -0.22713,21.63736 5.50686,30.59842 2.0556,3.21247 9.34899,10.41159 12.52529,12.3634 7.75573,4.76584 15.98466,6.74361 24.87441,5.97839 2.76435,-0.23796 7.49203,-1.02315 7.75723,-1.28837 0.0627,-0.0627 -11.15667,-11.38449 -24.93181,-25.15962 z"
            />
          </g>
        </svg>
      )}
      {!hideWordmark && <span className="font-bold">{APP_NAME}</span>}
    </div>
  );
}
